import Web3 from 'web3';
import contractData from './NewTokenABI.json';  // Ensure the ABI is correct and in the same path
import ERC20TokenABI from './TokenABI.json';
import { RPC_BASE_URL } from './endpoints';

const ABI = contractData.abi;

// export const getWeb3 = () => {
//   if (window.ethereum) {
//     const web3 = new Web3(window.ethereum);
//     return web3;
//   } else {
//     console.error("MetaMask is not installed");
//     return null;
//   }
// };

export const getWeb3 = () => {
  const web3 = new Web3();
  
  // Set the provider to BSC Testnet RPC endpoint
  web3.setProvider(new Web3.providers.HttpProvider(RPC_BASE_URL));
  
  return web3;
};

export const getContract = (web3: Web3, contractAddress: string) => {
  return new web3.eth.Contract(ABI, contractAddress);
};

export const getTokenContract = (web3: Web3, contractAddress: string) => {
  return new web3.eth.Contract(ERC20TokenABI, contractAddress);
};

export const getBNBBalance = async (web3: Web3, walletAddress: string) => {
  try {
    const balance = await web3.eth.getBalance(walletAddress); // Returns balance in wei
    console.log("BNB balance in wei:", balance);

const balanceBNB = web3.utils.fromWei(balance, 'ether'); // Convert to BNB
console.log("BNB balance in BNB:", balanceBNB);

return balanceBNB; // Convert wei to BNB (ether)
  } catch (error) {
    console.error("Failed to fetch BNB balance", error);
    return '0';
  }
};

// Function to fetch USDT balance from the wallet address
export const getUSDTBalance = async (
  web3: Web3,
  usdtContractAddress: string,
  walletAddress: string
): Promise<string> => {
  try {
    const contract = getTokenContract(web3, usdtContractAddress);
    const address = web3.utils.toChecksumAddress(walletAddress);

    // Fetch raw balance
    const balance = await contract.methods.balanceOf(address).call();
    if (!balance) {
      console.error("Balance is undefined or invalid");
      return '0.00';
    }

    // Dynamically get token decimals
    const decimals = await contract.methods.decimals().call();

    // Divide using decimals and format to 2 decimal places
    const divisor = Math.pow(10, Number(decimals));
    const formatted = (Number(balance) / divisor).toFixed(2);

    return formatted;
  } catch (error) {
    console.error("Failed to fetch USDT balance", error);
    return '0.00';
  }
};